import Flickity from 'flickity';
import { TweenMax, Power2 } from 'gsap';

class Slider {
  constructor() {
    this.cursorContainer = document.querySelector('.js--slider');
    this.cursor = document.querySelector('.cursor--slider');
    this.cursorIcon = document.querySelector('.js--cursor-icon');
    this.nextButton = document.querySelector('.js--slider-next');
    this.prevButton = document.querySelector('.js--slider-prev');
    this.cells = document.querySelectorAll('.js--slider-cell');
    this.isDragging = false;
    this.prevButton.disabled = true;
    this.initialize();
    this.bindEvents();
    this.updateTabOrder();
    this.updateArrows();
  }

  bindEvents() {
    this.cursorContainer.addEventListener('mousemove', this.mouseMove.bind(this));
    this.cursorContainer.addEventListener('mouseleave', this.mouseLeave.bind(this));
    this.nextButton.addEventListener('click', this.goForward.bind(this));
    this.prevButton.addEventListener('click', this.goBackwards.bind(this));
  }

  mouseMove(e) {
    const x = e.clientX;
    const y = e.clientY;
    const cursorWidth = this.cursor.offsetWidth;

    this.cursorContainer.classList.add('cursor-is-moving');

    if (e.target.classList.contains('js--slider-link')) {
      TweenMax.to(this.cursor, 0.1, {
        autoAlpha: 0,
      });
    } else {
      TweenMax.to(this.cursor, 0.1, {
        autoAlpha: 1,
      });
    }

    TweenMax.to(this.cursor, 0.3, {
      x: x - cursorWidth / 2,
      y: y - cursorWidth / 2,
      ease: Power2.easeOut,
    });
  }

  mouseLeave() {
    this.cursorContainer.classList.remove('cursor-is-moving');
    TweenMax.to(this.cursor, 0.1, {
      opacity: 0,
    });
  }

  goForward() {
    this.flickity.next();
  }

  goBackwards() {
    this.flickity.previous();
  }

  updateArrows() {
    if (this.flickity) {
      if (this.flickity.slides.length === 1) {
        this.prevButton.disabled = true;
        this.nextButton.disabled = true;
      } else if (this.flickity.selectedIndex === 0) {
        this.prevButton.disabled = true;
        this.nextButton.disabled = false;
      } else if (this.flickity.selectedIndex >= this.flickity.slides.length - 1) {
        this.prevButton.disabled = false;
        this.nextButton.disabled = true;
      } else {
        this.prevButton.disabled = false;
        this.nextButton.disabled = false;
      }
    }
  }

  getFocusableElement(cell) {
    let focusableEl = false;

    if (cell.hasAttribute('href')) {
      // Cell itself is focusable
      focusableEl = cell;
    } else if (cell.getElementsByTagName('a').length > 0) {
      // Cell contains focusable link
      focusableEl = cell.getElementsByTagName('a')[0];
    }

    return focusableEl;
  }

  updateTabOrder() {
    this.cells.forEach(cell => {
      const focusableEl = this.getFocusableElement(cell);
      if (focusableEl) {
        // Remove cell from tab order if not visible
        if (cell.getAttribute('aria-hidden') === 'true') {
          focusableEl.setAttribute('tabindex', -1);
        } else {
          focusableEl.setAttribute('tabindex', 0);
        }
      }
    });
  }

  initialize() {
    this.flickity = new Flickity('.js--slider-cells', {
      cellAlign: 'left',
      contain: true,
      selectedAttraction: 0.15,
      friction: 0.9,
      imagesLoaded: true,
      percentPosition: false,
      wrapAround: false,
      groupCells: true,
      pageDots: false,
      prevNextButtons: false,
      freeScroll: false,
      draggable: true,
      on: {
        pointerDown: () => {
          TweenMax.to(this.cursor, 0.3, {
            scale: 0.3,
            backgroundColor: '#ff4637',
            ease: Power2.easeInOut,
          });

          TweenMax.to(this.cursorIcon, 0.3, {
            opacity: 0,
            ease: Power2.easeInOut,
          });
        },
        pointerUp: () => {
          TweenMax.to(this.cursor, 0.3, {
            scale: 1,
            backgroundColor: 'transparent',
            ease: Power2.easeInOut,
          });

          TweenMax.to(this.cursorIcon, 0.3, {
            opacity: 1,
            ease: Power2.easeInOut,
          });
        },
        pointerMove: (event, pointer) => {
          const x = pointer.clientX;
          const y = pointer.clientY;
          const cursorWidth = this.cursor.offsetWidth;

          TweenMax.to(this.cursor, 0.3, {
            x: x - cursorWidth / 2,
            y: y - cursorWidth / 2,
            ease: Power2.easeOut,
          });
        },
        cellSelect: () => {
          this.updateArrows();
        },
        change: () => {
          this.updateTabOrder();
        },
        ready: () => {
          this.flkty = Flickity.data('.js--slider-cells');
          setTimeout(() => this.flkty.resize(), 500);
        },
      },
    });
  }
}

export default Slider;
